import CongresOverlay from '@/components/congres-overlay';
import ContentLayout from '@/components/layout/ContentLayout';
import { QuizCarousel } from '@/components/quiz-carousel';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import { ROUTE } from '@/routes/constants';
import { createQuiz, getExtensionQuestionList, getQuestionList, getTopicListByQuestionInfoIdList, publishAssignment } from '@/services/generatedAPIs';
import { useSubjectList } from '@/hooks/use-subject-list';
import { toast } from 'sonner';
import { GetQuestionListResponse, QuestionModel, UserInfoResponse } from '@/services/generatedAPIs.schemas';
import { FilePlus, FileSearch2, FileX, Plus } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavigateFunction, useLocation, useNavigate } from 'react-router';


const onSubmit = async (subjectId: number, subject: string, questionModelList: QuestionModel[], currentUser: UserInfoResponse, navigate: NavigateFunction, language?: string, titleKey?: string) => {  try {
    // setIsLoading(true);
    const questionInfoIds = questionModelList.map((questionModel) => questionModel.questionInfo.id!);
    const topicIdsRsp = await getTopicListByQuestionInfoIdList({ questionInfoIdList: questionInfoIds });
    const topicIds = topicIdsRsp.data!.topicInfos.map((questionLabel) => { return questionLabel.id! });
    const quizRsp = await createQuiz({
      title: "",
      subject: subject,
      subjectId: subjectId,
      originName: currentUser.name,
      language: language ?? "zh-HK",
      originType: "student",
      teacher_id: currentUser.id,
      topicIds: topicIds,
      questionInfoIds: questionInfoIds,
    })
    const assignmentRsp = await publishAssignment({
      title: "",
      type: "practice",
      studentId: currentUser.id,
      quizId: quizRsp.data!.id,
      topicIds: topicIds,
    })
    console.log('publish assignment ', assignmentRsp);
    if (assignmentRsp.code === 200 && assignmentRsp.data) {
      // titleKey 透传: 自循环继续抓延伸题时保留原入口标题
      navigate(ROUTE.STUDENT.PRACTICE_EDIT, { state: { assignmentId: assignmentRsp.data, studentId: currentUser.id, incremental: true, titleKey: titleKey } });
    }
  } catch (e) {
    console.log('error publish assignment ', e);
  } finally {
    // setIsLoading(false);
  }
};

const PracticeEditPage = () => {
    const {t, i18n} = useTranslation();
    const { getCurrentUser } = useAuth();
    const navigate = useNavigate();
    const state = useLocation().state;
    const { subjectInfos } = useSubjectList();
    const firstSubject = subjectInfos[0];
    const [questionListResponse, setQuestionListResponse] = React.useState<GetQuestionListResponse>();
    const [index, setIndex] = React.useState(0);
    const incremental = state?.incremental ?? false;
    // 入口模块标题键 (更多習題 / 錯題重練 / 自由主題); 未带 (例如直接进入) 回退到 隨心練
    const titleKey: string = state?.titleKey ?? 'student.practice';
    const [showCongres, setShowCongres] = React.useState(false);

    React.useEffect(() => {
       if (!state?.assignmentId || !state?.studentId) {
         console.error('Missing required state parameters: assignmentId or studentId');
         navigate(ROUTE.STUDENT.PRACTICE_HOME);
         return;
       }
       // Only fetch if not already loaded
       if (!questionListResponse) {
         getQuestionList({ assignmentId: state.assignmentId, studentId: state.studentId, newest: true }).then((rsp) => {
              if (rsp.code === 200 && rsp.data) {
                setQuestionListResponse(rsp.data);
              } else {
                console.log('Error getQuestionList', rsp)
              }
          }).catch((e) => {
            console.log('Error getQuestionList', e)
          });
       }
    }, [state?.assignmentId, state?.studentId, questionListResponse, navigate]);

    return (
        <ContentLayout title={t(titleKey)} backgroundColor="var(--practice-page-bg)" className="md:h-full md:overflow-hidden">
            <CongresOverlay isLoading={showCongres} text={t('student.congres')}></CongresOverlay>
            {/* lg/xl 左 padding 对齐 2xl 的 pl-0(内容贴近侧栏,gap≈24)；2xl/1920 不变 */}
            <div className="mx-auto w-full max-w-[2000px] px-6 pt-6 pb-6 lg:pl-0 lg:pr-6 2xl:pl-0 2xl:pr-6 min-[1920px]:max-w-none min-[1920px]:px-6 md:flex md:min-h-0 md:flex-1 md:flex-col">
                <div className="rounded-[30px] bg-[#F3F3F4] p-6 lg:p-10 xl:rounded-[38px] 2xl:ml-auto 2xl:w-full 2xl:max-w-[1433px] 2xl:rounded-[44px] min-[1920px]:max-w-none! min-[1920px]:rounded-[50px]! md:min-h-0 md:flex-1 md:overflow-y-auto">
                   { (questionListResponse && questionListResponse.questionModelList.length > 0) && <QuizCarousel key={index} quizProps={{
                    assignmentId: questionListResponse.assignmentId,
                    questionModelList: incremental === true ? [questionListResponse.questionModelList[index]] : questionListResponse.questionModelList,
                    assignmentStat: questionListResponse.assignmentStat
                   }} readonly={false} onFinish={() => {
                    setShowCongres(true);
                    setTimeout(() => {
                      setShowCongres(false);
                      if (index === (questionListResponse.questionModelList.length - 1)) {
                        getExtensionQuestionList({ studentId: getCurrentUser()!.id, assignmentId: 0 }).then((rsp) => {
                          console.log('getExtensionQuestionList', rsp.data?.questionModelList);
                          if (rsp.code === 200 && rsp.data) {
                            if (!rsp.data.questionModelList?.length) { toast.info(t('component.noQuestionText') ?? 'No questions available.'); return; }
                            if (!firstSubject) { toast.error(t('common.loading')); return; }
                            onSubmit(firstSubject.id!, firstSubject.name!, rsp.data.questionModelList, getCurrentUser()!, navigate, i18n.language, titleKey);
                          }
                        }).catch((e) => {
                          console.log('getExtensionQuestionList error', e)
                        });
                      } else {
                        setIndex(index + 1);
                      }
                    }, 3000);
                   }}></QuizCarousel> }
                </div>
            </div>
        </ContentLayout>
    );
};

export default PracticeEditPage;